import { CALL_API } from '../../api';
import * as ActionTypes from './transaction.actionTypes';
import * as UserActions from '../user/user.actions';
import schema from '../../api/schema';

export const invalidateTransactionsForTeam = (id) => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.INVALIDATE_TEAM_TRANSACTIONS,
    payload: {
      id
    }
  });

  return dispatch(readTransactionsForTeam(id));
};

export const invalidateTransactionsForRegion = (id) => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.INVALIDATE_TRANSACTIONS,
    payload: {
      id
    }
  });

  return dispatch(readTransactionsForRegion(id));
};

export const invalidateTransactionsForChannel = (id) => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.INVALIDATE_TRANSACTIONS,
    payload: {
      id
    }
  });

  return dispatch(readTransactionsForChannel(id));
};

const readTransactions = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TRANSACTIONS_REQUEST,
      ActionTypes.READ_TRANSACTIONS_SUCCESS,
      ActionTypes.READ_TRANSACTIONS_FAILURE,
    ],
    endpoint: 'api/transaction/all',
    schema: schema.transactionsSchema,
    authorization: true,
  }
});

export const getTransactions = () => (dispatch, getState) => {
  return dispatch(readTransactions());
};

const readTransactionsForTeam = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TRANSACTIONS_REQUEST,
      ActionTypes.READ_TRANSACTIONS_SUCCESS,
      ActionTypes.READ_TRANSACTIONS_FAILURE,
    ],
    endpoint: `api/transaction/team/${id}`,
    schema: schema.transactionsSchema,
    authorization: true,
  }
});

export const getTransactionsForTeam = (id) => (dispatch, getState) => {
  return dispatch(readTransactionsForTeam(id));
};

const readTransactionsForRegion = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TRANSACTIONS_REQUEST,
      ActionTypes.READ_TRANSACTIONS_SUCCESS,
      ActionTypes.READ_TRANSACTIONS_FAILURE,
    ],
    endpoint: `api/transaction/region/${id}`,
    schema: schema.transactionsSchema,
    authorization: true,
  }
});

export const getTransactionsForRegion = (id) => (dispatch, getState) => {
  return dispatch(readTransactionsForRegion(id));
};

const readTransactionsForChannel = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TRANSACTIONS_REQUEST,
      ActionTypes.READ_TRANSACTIONS_SUCCESS,
      ActionTypes.READ_TRANSACTIONS_FAILURE,
    ],
    endpoint: `api/transaction/channel/${id}`,
    schema: schema.transactionsSchema,
    authorization: true,
  }
});

export const getTransactionsForChannel = (id) => (dispatch, getState) => {
  return dispatch(readTransactionsForChannel(id));
};

const readTransactionsForUser = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TRANSACTIONS_REQUEST,
      ActionTypes.READ_TRANSACTIONS_SUCCESS,
      ActionTypes.READ_TRANSACTIONS_FAILURE,
    ],
    endpoint: `api/transaction/user/${id}`,
    schema: schema.transactionsSchema,
    authorization: true,
  }
});

export const getTransactionsForUser = (id) => (dispatch, getState) => {
  return dispatch(readTransactionsForUser(id));
};

const readTransaction = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TRANSACTION_REQUEST,
      ActionTypes.READ_TRANSACTION_SUCCESS,
      ActionTypes.READ_TRANSACTION_FAILURE,
    ],
    endpoint: `api/transaction/${id}`,
    schema: schema.transactionSchema,
    authorization: true,
  },
  payload: {
    id
  }
});

export const getTransaction = (id) => (dispatch, getState) => {
  const transaction = getState().entities.transaction.byId[id];
  if (transaction) {
    return Promise.resolve();
  }
  return dispatch(readTransaction(id));
};

const doCreateTransaction = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_TRANSACTION_REQUEST,
      ActionTypes.CREATE_TRANSACTION_SUCCESS,
      ActionTypes.CREATE_TRANSACTION_FAILURE,
    ],
    endpoint: 'api/transaction/',
    schema: schema.transactionsSchema,
    authorization: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  }
});

export const createTransaction = (data) => (dispatch, getState) => {
  return dispatch(doCreateTransaction(data)).then((response) => {
    if(!response.error) {
      dispatch(
        UserActions.invalidateUser(response.response.entities.transaction[response.response.result[0]].user._id)
      );
    }
    return response;
  });
};

const doUpdateTransaction = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_TRANSACTION_REQUEST,
      ActionTypes.UPDATE_TRANSACTION_SUCCESS,
      ActionTypes.UPDATE_TRANSACTION_FAILURE,
    ],
    endpoint: `api/transaction/${data._id}`,
    schema: schema.transactionSchema,
    authorization: true,
    requestInit: {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  },
  payload: {
    id: data._id
  }
});

export const updateTransaction = (data) => (dispatch, getState) => {
  return dispatch(doUpdateTransaction(data));
};

const doDeleteTransaction = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_TRANSACTION_REQUEST,
      ActionTypes.DELETE_TRANSACTION_SUCCESS,
      ActionTypes.DELETE_TRANSACTION_FAILURE,
    ],
    endpoint: `api/transaction/${id}`,
    schema: schema.transactionSchema,
    authorization: true,
    requestInit: {
      method: 'DELETE',
    },
  },
  payload: {
    id
  }
});

export const deleteTransaction = (id) => (dispatch, getState) => {
  return dispatch(doDeleteTransaction(id)).then(() => {
    dispatch(
      UserActions.invalidateCurrentUser()
    );
  });
};


// WEBPACK FOOTER //
// ./src/modules/transaction/transaction.actions.js